import React from 'react';
import { Checkbox } from 'src/components/inputs';
import * as S from './styles';

export type Props = {
  title: string;
  name: string;
  text: string;
  handleChange: (name: any) => void;
  checked?: number;
  disabled?: boolean;
  indent?: boolean;
};

const TrackingSettingCheckbox = (props: Props) => {
  const checked = !!props.checked;

  return (
    <S.TrackingSetting indent={props.indent}>
      <Checkbox
        name={props.name}
        onChange={() => props.handleChange(props.name)}
        checked={checked}
        disabled={props.disabled}
      >
        <S.TrackingSettingLabel>{props.title}</S.TrackingSettingLabel>
      </Checkbox>
      {props.text}
    </S.TrackingSetting>
  );
};

export default TrackingSettingCheckbox;
